var _defs, _polygon, _path, _path2, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgURlogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.63 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.79 40 23.02 40 23.02 12.99 28.79 5.85 28.79 40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.26,30.39V5.85l5.77,8.44.07,15.94c0,3.54,1.47,4.95,3.92,4.95s3.89-1.41,3.89-4.95v-4.5l5.41,8.02h0c-.44,2.5-3.26,6.27-9.37,6.27s-9.7-3.44-9.7-9.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.63,22.63c0-5.18-3.85-8.37-10.02-8.37h-7.44L41.52,0h-6.46l27.03,39.59h6.25l-6.15-9.07c4.02-1.03,6.44-3.84,6.44-7.89Zm-10.31-4.02c3.26,0,4.91,1.49,4.91,4.02,0,2.18-1.25,3.58-3.73,3.91l-5.37-7.93h4.2Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.26 40 11.49 40 11.49 24.45 17.26 17.3 17.26 40"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.77 40 0 40 0 35.8 5.77 28.65 5.77 40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgURlogoWhite);
export default __webpack_public_path__ + "static/media/URlogoWhite.3b0f8a993cf81c7b949570337f0345aa.svg";
export { ForwardRef as ReactComponent };